import { render, staticRenderFns } from "./RecuperaPassword.vue?vue&type=template&id=410f773e&scoped=true"
import script from "./RecuperaPassword.vue?vue&type=script&lang=js"
export * from "./RecuperaPassword.vue?vue&type=script&lang=js"
import style0 from "../assets/css/login.css?vue&type=style&index=0&id=410f773e&prod&scoped=true&lang=css&external"
import style1 from "../assets/css/util.css?vue&type=style&index=1&id=410f773e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410f773e",
  null
  
)

export default component.exports